const toggleSubMenuClass = (element, toggle) => {
  const parentElem = element.closest('.menu__item');
  parentElem.classList.toggle('is-open-submenu', toggle);
  document.body.classList.toggle('is-submenu-visible', toggle);
  document.body.classList.remove('submenu-hidden');
  toggleBodyScrollLock(toggle);
};

const submenuToggle =
  windowWidth() < breakpointMd
    ? '.menu__item.has-sub-menu .menu__link.level-1, .menu__arrow.level-2'
    : '.menu__item.has-sub-menu .menu__link.level-1';

attachEvent(submenuToggle, 'click', (ev) => {
  const isOpen = ev.target.closest('.menu__item').classList.contains('is-open-submenu');
  toggleSubMenuClass(ev.target, !isOpen);
  ev.preventDefault();
});

attachEvent('.menu__back-btn, .menu__dropdown-close', 'click', (ev) => {
  toggleSubMenuClass(ev.target, false);
  document.body.classList.add('submenu-hidden');
  ev.preventDefault();
});

// Close Modal on ESC key press
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.menu__item').forEach((ele) => {
      ele.classList.remove('is-open-submenu');
      document.body.classList.remove('is-submenu-visible');
      document.body.classList.add('submenu-hidden');
      toggleBodyScrollLock(false);
    });
  }
});

// Mouseenter/Mouseleave
const menuItemsL2 = document.querySelectorAll('.menu__item.level-2.has-sub-menu');

let openingTimer;
let closingTimer;

menuItemsL2.forEach((item) => {
  item.addEventListener('mouseenter', (el) => {
    clearTimeout(closingTimer); 
    openingTimer = setTimeout(() => {
      closeOpenMenus();
      el.target.classList.add('is-open');
    }, 200);
  });

  item.addEventListener('mouseleave', (el) => {
    clearTimeout(openingTimer); 
    closingTimer = setTimeout(() => {
      el.target.classList.remove('is-open');
    }, 200);
  });
});

function closeOpenMenus() {
  const openItem = document.querySelector('.menu__item.level-2.is-open');
  if (openItem) {
    openItem.classList.remove('is-open');
  }
}
